export const PublicLayout = (props) => {
  //A simple returning hoc for unauthenticated userss
  return props.children;
};
